export default [{
    text: 'Длительно',
    value: 'longTerm',
}, {
    text: 'Несколько месяцев',
    value: 'fewMonths',
}];
